import React from 'react';
import PropTypes from 'prop-types';
import './MFAFailureModal.css';
import closeIcon from "../../assets/images/mfa/close-icon.svg";

const MFAFailureModal = ({ isOpen, onClose, onStartOver, onTryAgain }) => {
    if (!isOpen) return null;

    return (
        <div className="mfa-modal-overlay">
            <div className="mfa-modal-content">
                <div className="mfa-modal-header">
                    <h2 className="mfa-modal-title">Configuration Failed</h2>
                    <button className="mfa-modal-close-btn" onClick={onClose}>
                        <img src={closeIcon} alt="close" className='close-icon-img' />
                    </button>
                </div>
                <div className="mfa-modal-body">
                    <p className="mfa-modal-text">
                        The configuration process failed due to unknown error.
                    </p>
                    <p className="mfa-modal-text">Kindly try to login again.</p>
                </div>
                <div className="mfa-modal-footer">
                    <button className="mfa-start-over-btn" onClick={onStartOver}>
                        Start over
                    </button>
                    <button className="mfa-try-again-btn" onClick={onTryAgain}>
                        Try Again
                    </button>
                </div>
            </div>
        </div>
    );
};

MFAFailureModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onStartOver: PropTypes.func.isRequired,
    onTryAgain: PropTypes.func.isRequired,
};

export default MFAFailureModal;